const BaseModalTopArea = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="419"
      height="26"
      viewBox="0 0 419 26"
      fill="none"
    >
      <path
        d="M419 25.4989L419.131 24.5163C363.785 9.49972 268.879 0.500001 187.386 0.5C123.359 0.498779 63.9737 2.99927 -0.0734002 12.5044L-0.5 12.5677V12.999V24.9989V25.4989H0H419Z"
        fill="var(--component-modal-surface)"
      />
      <path
        d="M-0.5 25.4989V12.5677L-0.0734002 12.5044C63.9737 2.99927 123.359 0.498779 187.386 0.5C268.879 0.500001 363.785 9.49972 419.131 24.5163L419 25.4989"
        stroke="var(--border-color-primary)"
      />
    </svg>
  )
}

export default BaseModalTopArea
